const columns = [
  {
    name: 'User ID',
    selector: (row) => row?.user_id,
    sortable: true,
    sortField: 'user_id',
  },
  {
    name: 'WMRC Name',
    selector: (row) => row?.wmrc_name,
    sortable: true,
    sortField: 'wmrc_name',
  },
  {
    name: 'Average Response Seconds',
    selector: (row) => row?.avg_response_seconds,
    sortable: true,
    sortField: 'avg_response_seconds',
  },
  {
    name: 'Average Response Time',
    selector: (row) => row?.avg_response_time,
    // sortable: true,
    // sortField: 'avg_response_time',
  },
];
export { columns };


export const mobileColumns = [
  {
    name: 'User ID',
    selector: (row) => row?.user_id,
    sortable: true,
    sortField: 'user_id',
  },
  {
    name: 'WMRC Name',
    selector: (row) => row?.wmrc_name,
    sortable: true,
    sortField: 'wmrc_name',
  },
  {
    name: 'Average Response Seconds',
    selector: (row) => row?.avg_response_seconds,
    sortable: true,
    sortField: 'avg_response_seconds',
  },
  {
    name: 'Average Response Time',
    selector: (row) => row?.avg_response_time,
    sortable: true,
    sortField: 'avg_response_time',
  },
]